/* eslint-disable @typescript-eslint/no-explicit-any */

import { isAxiosError } from 'axios';
import { apiClient } from '@/axios';
import { Endpoints } from '@/enums';
import { ContainerDataType } from '@/types/containerData';

type GetCardContainerDataResponse = {
  isFaulted: boolean;
  isSuccess: boolean;
  state: number;
  exception: unknown;
  value: {
    value: unknown[];
    exception: any;
    contenedorStock: ContainerDataType;
    parteIntercambio: unknown[];
    logsLiberacion: unknown[];
  };
};

type QueryType = {
  marca: string;
  numero: string;
};

export const getCardContainerData = async (
  query: QueryType
): Promise<ContainerDataType | null> => {
  try {
    const res = await apiClient.post<GetCardContainerDataResponse>(
      Endpoints.container,
      query
    );
    const { contenedorStock, parteIntercambio, logsLiberacion } =
      res.data.value;

    return { ...contenedorStock, parteIntercambio, logsLiberacion };
  } catch (error) {
    if (isAxiosError(error)) {
      throw new Error(error.message);
    }
    throw error;
  }
};
